import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, ChevronDown, Rss } from "lucide-react";
import { Button } from "../ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { GroupedNavigation } from "./GroupedNavigation";
import { publicNavigation } from "./navigationGroups";

export const SiteNavigation = ({ scope = "site", compact = false, extraLinks = [] }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const groups = publicNavigation.map(group => group.id === "community" && extraLinks.length
    ? { ...group, items: [...group.items, ...extraLinks.map(item => ({ ...item, icon: item.icon || Rss }))] } : group);
  const current = location.pathname + location.search;
  return (
      <div className={compact ? "site-navigation-compact" : "site-navigation-menu"} data-testid={`${scope}-navigation-container`}>
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button variant="outline" className="site-navigation-trigger" data-testid={`${scope}-menu-button`} aria-label="Open navigation">
              <Menu className="h-4 w-4" aria-hidden="true" /><span className="menu-trigger-label">Menu</span><ChevronDown className="menu-trigger-chevron h-3 w-3" aria-hidden="true" />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" collisionPadding={12} sideOffset={12} className="site-navigation-panel" data-testid={`${scope}-navigation-panel`}>
            <div className="site-navigation-panel-header">
              <span data-testid={`${scope}-menu-title`}>Navigation</span>
              <Button variant="ghost" size="icon" className="navigation-close-button" onClick={() => setOpen(false)} aria-label="Close navigation" data-testid={`${scope}-menu-close`}><X className="h-4 w-4" /></Button>
            </div>
            <nav aria-label="Explore StardomFans">
              <GroupedNavigation groups={groups} pathname={current} scope={`${scope}-mobile`} onNavigate={() => setOpen(false)} exact />
            </nav>
          </PopoverContent>
        </Popover>
      </div>
  );
};